<template>
  <div class="login">
    <div class="panel">
      <p class="title">登录</p>
      <p class="subtitle">欢迎登录应急资产管理大屏系统</p>
      <el-form :model="form" @submit.native.prevent="onSubmit" label-width="0">
        <el-form-item>
          <el-input v-model="form.password" type="password" show-password placeholder="请输入密码">
            <i slot="prefix" class="el-icon-lock"></i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" :loading="loading">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
  </template>
  
  <script>
  import { login } from '@/api/path/biApi'
  import { setLocal } from '@/utils/auth'
  
  export default {
    name: 'Login',
    data() {
      return {
        form: {
          password: ''
        },
        loading: false
      }
    },
    methods: {
      async onSubmit() {
        if (!this.form.password) {
          this.$message.error('请输入密码')
          return
        }
        this.loading = true
        try {
          const res = await login({ pwd: this.form.password })
          if (res && res.code === 1) {
            const token = res.data && (res.data.token || res.data)
            if (token) {
              setLocal(token)
              this.$store.commit('bi/SET_TOKEN', token)
              this.$router.replace('/')
            } else {
              const msg = (res && res.msg) ? res.msg : '登录返回缺少token'
              this.$message.error(msg)
            }
          } else {
            // 全局拦截器已处理错误提示，这里不再重复提示
          }
        } catch (e) {
          this.$message.error('登录异常', e)
        } finally {
          this.loading = false
        }
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .login {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url('~@/assets/img/login_bg_img.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .panel {
    width: 420px;
    padding: 40px 35px 40px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 24px 48px rgba(0, 0, 0, 0.36), 0 2px 8px rgba(0, 0, 0, 0.18);
    border: 1px solid rgba(255, 255, 255, 0.8);
    position: relative;
  }
  .title {
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 15px;
    display: inline-block;
    background: linear-gradient(90deg, #1a9bff 0%, #6f86ff 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    position: relative;
  }
  .title::after {
    content: "";
    display: block;
    width: 100%;
    height: 4px;
    margin-top: 8px;
    background: linear-gradient(90deg, #1a9bff 0%, #6f86ff 100%);
    border-radius: 9999px;
  }
  .subtitle {
    margin-bottom: 30px;
    font-size: 16px;
    color: #588BFF;
    font-weight: bold;
  }
  .el-form {
    .el-input {
      height: 40px;
      line-height: 40px;
    }
    .el-input__inner {
      height: 40px;
      line-height: 40px;
      border-radius: 9999px;
    }
    .el-form-item:last-child {
      margin-bottom: 0;
    }
  }
  .el-button {
    width: 100%;
    height: 40px;
    border: 0;
    border-radius: 9999px;
    background: linear-gradient(90deg, #1a9bff 0%, #7b5cff 100%);
  }
  </style>
